
import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
//import {BranchElement} from "../../Models/ApplicationModels/BranchModel";
import {ImageElement} from "../models/ImageModel";

import { environment } from '../../environments/environment';
//   private apiUrl = environment.apiUrl;

@Injectable()
export class ImageService {

   /// import { environment } from '../../../environments/environment';
   private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  /////////////////////////  ------------  GET ALL ------------


  getAllImageVcdForData() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/Image/GetAllImageVcdFor",httpOptions);
  }


  getAllImageVcdCategoryData( imageforid:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/Image/GetAllImageVcdCategory?ImageForId="+imageforid,httpOptions);
  }



  ///////////////////////  ----------- GET ALL BY ID -----------


  getAllImageVcdPathMapData( mids:number, notess:string , imgforids:number , ivids:number ,ff1:string ,ff2:string ,ff3:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/Image/GetAllImageVcdPathMap?mid="+mids+"&notes="+notess+"&imgforid="+imgforids+"&ivid="+ivids+"&f1="+ff1+"&f2="+ff2+"&f3="+ff3,httpOptions);
  }


  deleteImageVcdPathData( imageid:number, machineip:string , createdby:number  ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.post(""+this.apiUrl+"/Image/DeleteImageVcdPath?ImageId="+imageid+"&MachineIP="+machineip+"&CreatedBy="+createdby,httpOptions);
  }



  /////////////////////////////  ------------- CURD -----------------


  // addImageVcdPathData(app:ImageElement) {
  //   var httpOptions = {
  //     headers: new HttpHeaders({
  //         'Content-Type': 'application/json',
  //         'Access-Control-Allow-Origin': '*',
  //         'Access-Control-Allow-Credentials': 'true',
  //         'Access-Control-Allow-Headers': 'Content-Type',
  //         'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
  //         'key': 'x-api-key',
  //         'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

  //     })
  // };
  // return this.http.post('"+this.apiUrl+"/Image/AddImageVcdPath',
  // JSON.stringify(app),
  //  httpOptions
  // )
  // }




}
